/* @flow */
import _ from 'lodash';

import { callApiEndpoint } from './index';
import utils from './utils';

import type {
  MediaSortingField,
  Media,
  MediaSearchResults,
  MediaSearchFullParams,
} from '../../types';

const toFieldName = (field: MediaSortingField) => {
  switch (field) {
    case 'title':
      return 'titolo';
    default:
      return undefined;
  }
};

const find = async (params: MediaSearchFullParams): Promise<MediaSearchResults> => {
  const {
    sorting,
    filters,
    filtersMeta = {},
    news,
    text,
    flags = {},
    excludeProductionMusic,
    categoryIds,
    featuredId,
  } = params;
  const sort = sorting
    ? {
        fieldName: toFieldName(sorting.field),
        reverse: sorting.order !== 'asc',
      }
    : null;

  const response = await callApiEndpoint('supporti/search', {
    method: 'POST',
    body: {
      queryType: news ? 'NEWS' : 'DEFAULT',
      query: text || '',
      queryTitolo: flags.title || false,
      queryPeople: flags.people || false,
      queryTags: flags.tags || false,
      titolareId: featuredId || null,
      excludeProductionMusic: excludeProductionMusic || false,
      categoriaIds: categoryIds || [],
      categoriaIdsFilter: _.get(filtersMeta, 'categories.filter', null),
      categoriaIdsSize: _.get(filtersMeta, 'categories.pagination', 10),
      interpreti: _.get(filters, 'performers', []),
      interpretiFilter: _.get(filtersMeta, 'performers.filter', null),
      interpretiSize: _.get(filtersMeta, 'performers.pagination', 10),
      autori: _.get(filters, 'authors', []),
      autoriFilter: _.get(filtersMeta, 'authors.filter', null),
      autoriSize: _.get(filtersMeta, 'authors.pagination', 10),
      tags: _.get(filters, 'tags', []),
      tagsFilter: _.get(filtersMeta, 'tags.filter', null),
      tagsSize: _.get(filtersMeta, 'tags.pagination', 8000),
      anni: _.get(filters, 'years', []),
      anniFilter: _.get(filtersMeta, 'years.filter', null),
      anniSize: _.get(filtersMeta, 'years.pagination', 10),
      editori: _.get(filters, 'editors', []),
      editoriFilter: _.get(filtersMeta, 'editors.filter', null),
      editoriSize: _.get(filtersMeta, 'editors.pagination', 10),
      etichette: _.get(filters, 'labels', []),
      etichetteFilter: _.get(filtersMeta, 'labels.filter', null),
      etichetteSize: _.get(filtersMeta, 'labels.pagination', 10),
      produttori: _.get(filters, 'producers', []),
      produttoriFilter: _.get(filtersMeta, 'producers.filter', null),
      produttoriSize: _.get(filtersMeta, 'producers.pagination', 10),
      collectings: _.get(filters, 'collectings', []),
      collectingsFilter: _.get(filtersMeta, 'collectings.filter', null),
      collectingsSize: _.get(filtersMeta, 'collectings.pagination', 10),
      cataloghi: _.get(filters, 'catalogs', []),
      cataloghiFilter: _.get(filtersMeta, 'catalogs.filter', null),
      cataloghiSize: _.get(filtersMeta, 'catalogs.pagination', 10),
      sort,
      ...(params.pagination || { start: 0, end: 10000 }),
    },
  });
  // ignoro dati aggiuntivi della risposta e prendo il primo elemento di un array (con un unico elemento)
  const results = _.fromPairs(
    response.categorie.map(({ id, total, supporti }) => [
      id,
      {
        total,
        hits: supporti.map(({ _source }) => utils.toMedia(_source)),
      },
    ])
  );
  const aggregations = response.others
    .map(other => utils.toMediaAggregations(other.aggregations))
    .find(() => true);
  results.aggregations = aggregations;
  return results;
};

const get = async (id: number): Promise<Media> => {
  let pathUrl = id || 0;
  const endpoint = 'supporti/' + pathUrl + '/get';
  const response = await callApiEndpoint(endpoint, { params: {} });
  return utils.toMedia(response);
};

export default {
  find,
  get,
};
